import { InboxOutlined } from '@ant-design/icons'
import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
const Container = styled.div``
const SubContainer = styled.div``

const Overdue = (props) => {
  const { data_aging, word } = props
  const history = useHistory()
  const ContainerState = () => {
    if (data_aging.overdue?.length > 0) {
      return (
        <SubContainer className="sub-container-overdue">
          {data_aging.overdue?.map((val) => (
            <div className="container-overdue-detail">
              <div className="layout-overdue-detail">
                <div className="project-name-container">
                  <span
                    className="text-project-name-overdue small cutter-text-line-1"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      history.push({
                        pathname: `/project/${val.id}/edit`,
                      })
                    }}
                  >
                    {val.name}
                  </span>
                </div>
                <div className="progress-container">
                  <div
                    className="progress"
                    style={{
                      width: `${val.overdue_percent === 0 ? 1 : val.overdue_percent}%`,
                    }}
                  ></div>
                  <span className="small text-days">
                    {val.day_left} {val.day_left === 1 ? word['day'] : word['days']}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </SubContainer>
      )
    } else {
      return (
        <SubContainer>
          <div className="emytystate edit-height-emptystate-summary">
            <InboxOutlined className="inbox" />
            <p>
              {word['No']} {word['overdue_title']}
            </p>
          </div>
        </SubContainer>
      )
    }
  }
  return (
    <Container>
      <h3>{word['overdue_title']}</h3>
      {ContainerState()}
    </Container>
  )
}
export default Overdue
